function cc_format(value) {
  if (!value) return "";
  const numericValue = value.replace(/[^0-9]/g, "");
  const limitedValue = numericValue.slice(0, 16);
  const matches = limitedValue.match(/\d{1,4}/g);

  return matches ? matches.join(" ") : "";
}

export default cc_format;

// function cc_format(value) {
// 	if (!value) return;
// 	var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
// 	var matches = v.match(/\d{4,16}/g);
// 	var match = (matches && matches[0]) || '';
// 	var parts = [];
// 	for (let i = 0, len = match.length; i < len; i += 4) {
// 		parts.push(match.substring(i, i + 4));
// 	}

// 	if (parts.length) {
// 		return parts.join(' ');
// 	} else {
// 		return value;
// 	}
// }

// export default cc_format;
